/**
 * Supprime les avertissements spécifiques de React concernant defaultProps
 * dans react-beautiful-dnd qui ne peuvent pas être résolus autrement
 */

// Sauvegarder la fonction console.warn originale
const originalWarn = console.warn;

// Remplacer console.warn pour filtrer les avertissements spécifiques
console.warn = (...args) => {
  // Convertir tous les arguments en chaîne pour la vérification
  const message = args.join(" ");

  // Filtrer tous les avertissements liés à defaultProps
  if (
    message.includes("Support for defaultProps will be removed") ||
    message.includes("defaultProps will be removed from memo components") ||
    message.includes("Connect(Droppable)") ||
    message.includes("Connect(Draggable)") ||
    message.includes("DroppableWrapper") ||
    message.includes("DraggableWrapper")
  ) {
    // Ne pas afficher ces avertissements
    return;
  }

  // Afficher tous les autres avertissements normalement
  originalWarn.apply(console, args);
};

// Également intercepter console.error pour les avertissements qui pourraient y apparaître
const originalError = console.error;
console.error = (...args) => {
  const message = args.join(" ");

  if (
    message.includes("Support for defaultProps will be removed") ||
    message.includes("defaultProps will be removed from memo components") ||
    message.includes("Connect(Droppable)") ||
    message.includes("Connect(Draggable)")
  ) {
    return;
  }

  originalError.apply(console, args);
};

// Exporter une fonction pour restaurer le comportement original si nécessaire
export const restoreOriginalWarn = () => {
  console.warn = originalWarn;
  console.error = originalError;
};

export default {
  restoreOriginalWarn,
};
